import { get } from 'lodash'
import { Layer } from 'ol/layer'
import TileLayer from 'ol/layer/Tile'
import { XYZ } from 'ol/source'
import React, { ReactElement, useEffect, useState } from 'react'

import { useLayer } from '../Layer/useLayer'
import { useMapSettings } from '../MapSettings/useMapSettings'
import { getMapTiles } from '../mapTiles'
import { useMap } from '../useMap'

export const RasterBaseLayer = (): ReactElement => {
  const { settings } = useMapSettings()

  const [layer, setLayer] = useState<Layer | undefined>(undefined)

  const { map } = useMap()

  useEffect(() => {
    const maptiles = getMapTiles()
    const maptile = get(maptiles, settings.tileLayer, maptiles.standard)

    if (settings.isVector && maptile.vectorStyle) {
      // console.log('Hiding raster layer')
      setLayer(undefined)
      return
    }
    // console.log('Show raster layer')

    const isHiDPI = window.devicePixelRatio > 1

    const newLayer = new TileLayer({
      zIndex: 0,
    })
    const source = new XYZ({
      tileSize: 256,
      url: maptile.url,
      tilePixelRatio: isHiDPI ? 2 : 1,
    })
    newLayer.setSource(source)
    setLayer(newLayer)
  }, [settings.tileLayer, settings.isVector])

  useLayer({ layer })

  return <></>
}
